import { z } from 'zod';

/**
 * The office's note on one day — mirrors `attendanceNoteSchema` in the
 * backend's `staffAttendance.validation.ts`. The server decides; this is for
 * telling the office before it presses Save.
 */

export const ATTENDANCE_NOTE_MAX_LENGTH = 150;

/** The note is stored encrypted, so the bytes must fit as well as the characters. */
const ATTENDANCE_NOTE_MAX_BYTES = 450;

export const attendanceNoteSchema = z
  .string()
  .trim()
  .max(ATTENDANCE_NOTE_MAX_LENGTH, `Keep the note to ${ATTENDANCE_NOTE_MAX_LENGTH} characters`)
  .refine(
    (value) => new TextEncoder().encode(value).length <= ATTENDANCE_NOTE_MAX_BYTES,
    'That note is too long',
  );
